var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-link",on:{"click":function($event){return _vm.showPage(_vm.language)}}},[_c('div',{staticClass:"app-card -shadow",class:{
      notpublished: !_vm.language.publish,
      custom: _vm.language.custom,
    }},[_c('div',{staticClass:"language"},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.language.name))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }